var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgThirdLayer = function SvgThirdLayer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 674,
    viewBox: "0 0 444 674",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1 0V546H444V0H1Z",
    fill: "url(#paint0_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 255.585,
    height: 255.585,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 222.348 417.809)",
    fill: "#1D2535"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 255.585,
    height: 255.585,
    transform: "matrix(0.866044 0.499967 -0.866044 0.499967 222.346 385)",
    fill: "#2D5D6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.068 620.547L221.244 619.868C221.971 619.435 222.358 618.988 222.403 618.526C222.448 618.063 222.149 617.647 221.506 617.276C220.063 616.442 218.622 616.441 217.184 617.271C216.508 617.661 216.161 618.086 216.144 618.545C216.127 618.998 216.437 619.408 217.074 619.776L215.51 620.679C214.534 620.116 214.081 619.444 214.148 618.662C214.216 617.875 214.799 617.163 215.899 616.529C217.06 615.858 218.278 615.51 219.553 615.484C220.827 615.458 222.011 615.761 223.105 616.392C223.64 616.701 223.984 617.102 224.136 617.593C224.294 618.081 224.198 618.57 223.849 619.058C224.74 618.791 225.617 618.695 226.479 618.77C227.347 618.841 228.14 619.084 228.856 619.497C229.961 620.135 230.477 620.85 230.403 621.641C230.33 622.432 229.716 623.161 228.56 623.828C227.404 624.495 226.149 624.858 224.796 624.917C223.449 624.972 222.262 624.704 221.236 624.111L222.809 623.203C223.457 623.577 224.187 623.755 224.999 623.735C225.811 623.716 226.572 623.501 227.283 623.091C228.038 622.655 228.419 622.207 228.424 621.748C228.43 621.289 228.064 620.846 227.325 620.42C226.609 620.007 225.839 619.816 225.016 619.849C224.193 619.881 223.361 620.134 222.521 620.606L221.345 621.284L220.068 620.547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.844 620.005L222.53 612.896L226.006 610.889C227.077 610.271 228.261 609.861 229.558 609.659C230.855 609.457 232.163 609.48 233.482 609.727C234.807 609.972 236.039 610.419 237.178 611.07L237.964 611.524C239.126 612.195 239.918 612.912 240.341 613.677C240.769 614.439 240.8 615.196 240.434 615.948C240.073 616.696 239.346 617.393 238.252 618.037L234.844 620.005ZM225.49 612.73L235.14 618.301L236.848 617.315C238.1 616.592 238.683 615.806 238.599 614.957C238.52 614.104 237.761 613.262 236.324 612.432L235.605 612.017C234.206 611.21 232.791 610.774 231.359 610.709C229.927 610.637 228.602 610.946 227.384 611.636L225.49 612.73Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.745 607.96L242.853 609.63L247.834 612.506L246.202 613.448L233.888 606.339L237.964 603.986C239.351 603.185 240.733 602.752 242.109 602.687C243.49 602.618 244.784 602.933 245.991 603.629C246.757 604.072 247.217 604.578 247.369 605.148C247.527 605.714 247.378 606.292 246.921 606.881L255.04 608.228L255.142 608.287L253.399 609.293L245.745 607.96ZM241.525 608.863L244.02 607.423C244.826 606.957 245.258 606.468 245.314 605.953C245.376 605.436 245.057 604.975 244.358 604.571C243.597 604.132 242.785 603.927 241.923 603.956C241.065 603.982 240.206 604.241 239.343 604.733L236.856 606.168L241.525 608.863Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.667 598.961L260.74 602.438L254.719 594.313L256.825 593.098L269.139 600.207L267.515 601.144L262.719 598.376L257.696 595.3L263.624 603.39L262.381 604.108L248.401 600.695L253.712 603.575L258.508 606.344L256.884 607.281L244.57 600.172L246.667 598.961Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 543.013L26.7215 528.164L25.8755 527.675L1 542.036V543.013Z",
    fill: "#5C7F8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 539.594L23.7605 526.454L22.9145 525.966L1 538.617V539.594Z",
    fill: "#5C7F8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 536.175L20.7995 524.745L19.9534 524.256L1 535.198V536.175Z",
    fill: "#5C7F8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 532.756L17.8384 523.035L16.9924 522.547L1 531.779V532.756Z",
    fill: "#5C7F8B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 529.337L14.8774 521.326L14.0314 520.838L1 528.361V529.337Z",
    fill: "#5C7F8B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 525.919L11.9164 519.617L11.0704 519.128L1 524.942V525.919Z",
    fill: "#5C7F8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 522.5L8.95534 517.907L8.10933 517.419L1 521.523V522.5Z",
    fill: "#5C7F8B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 519.081L5.99432 516.198L5.14831 515.709L1 518.104V519.081Z",
    fill: "#5C7F8B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 515.662L3.03329 514.488L2.18728 514L1 514.685V515.662Z",
    fill: "#5C7F8B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61028 544.525L28.8365 529.385L29.6825 529.873L3.45629 545.013L2.61028 544.525Z",
    fill: "#5C7F8B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57131 546.234L31.7976 531.094L32.6436 531.582L6.41732 546.723L5.57131 546.234Z",
    fill: "#5C7F8B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53234 547.944L34.7586 532.803L35.6046 533.292L9.37835 548.432L8.53234 547.944Z",
    fill: "#5C7F8B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4934 549.653L37.7196 534.513L38.5656 535.001L12.3394 550.142L11.4934 549.653Z",
    fill: "#5C7F8B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4544 551.363L40.6806 536.222L41.5267 536.711L15.3004 551.851L14.4544 551.363Z",
    fill: "#5C7F8B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4154 553.072L43.6417 537.932L44.4877 538.42L18.2614 553.56L17.4154 553.072Z",
    fill: "#5C7F8B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3765 554.781L46.6027 539.641L47.4487 540.129L21.2225 555.27L20.3765 554.781Z",
    fill: "#5C7F8B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3375 556.491L49.5637 541.35L50.4097 541.839L24.1835 556.979L23.3375 556.491Z",
    fill: "#5C7F8B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2985 558.2L52.5248 543.06L53.3708 543.548L27.1445 558.689L26.2985 558.2Z",
    fill: "#5C7F8B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2595 559.91L55.4858 544.769L56.3318 545.258L30.1055 560.398L29.2595 559.91Z",
    fill: "#5C7F8B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2206 561.619L58.4468 546.479L59.2928 546.967L33.0666 562.107L32.2206 561.619Z",
    fill: "#5C7F8B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1816 563.328L61.4078 548.188L62.2539 548.676L36.0276 563.817L35.1816 563.328Z",
    fill: "#5C7F8B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1426 565.038L64.3689 549.897L65.2149 550.386L38.9886 565.526L38.1426 565.038Z",
    fill: "#5C7F8B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1037 566.747L67.3299 551.607L68.1759 552.095L41.9497 567.236L41.1037 566.747Z",
    fill: "#5C7F8B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0647 568.457L70.2909 553.316L71.1369 553.805L44.9107 568.945L44.0647 568.457Z",
    fill: "#5C7F8B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0257 570.166L73.252 555.026L74.098 555.514L47.8717 570.654L47.0257 570.166Z",
    fill: "#5C7F8B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9867 571.875L76.213 556.735L77.059 557.223L50.8327 572.364L49.9867 571.875Z",
    fill: "#5C7F8B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9478 573.585L79.174 558.444L80.02 558.933L53.7938 574.073L52.9478 573.585Z",
    fill: "#5C7F8B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9088 575.294L82.135 560.154L82.9811 560.642L56.7548 575.783L55.9088 575.294Z",
    fill: "#5C7F8B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8698 577.004L85.0961 561.863L85.9421 562.352L59.7158 577.492L58.8698 577.004Z",
    fill: "#5C7F8B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8309 578.713L88.0571 563.573L88.9031 564.061L62.6769 579.201L61.8309 578.713Z",
    fill: "#5C7F8B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7919 580.422L91.0181 565.282L91.8641 565.77L65.6379 580.911L64.7919 580.422Z",
    fill: "#5C7F8B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7529 582.132L93.9792 566.991L94.8252 567.48L68.5989 582.62L67.7529 582.132Z",
    fill: "#5C7F8B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7139 583.841L96.9402 568.701L97.7862 569.189L71.56 584.33L70.7139 583.841Z",
    fill: "#5C7F8B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.675 585.551L99.9012 570.41L100.747 570.899L74.521 586.039L73.675 585.551Z",
    fill: "#5C7F8B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.636 587.26L102.862 572.12L103.708 572.608L77.482 587.748L76.636 587.26Z",
    fill: "#5C7F8B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M79.597 588.969L105.823 573.829L106.669 574.317L80.443 589.458L79.597 588.969Z",
    fill: "#5C7F8B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5581 590.679L108.784 575.538L109.63 576.027L83.4041 591.167L82.5581 590.679Z",
    fill: "#5C7F8B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5191 592.388L111.745 577.248L112.591 577.736L86.3651 592.877L85.5191 592.388Z",
    fill: "#5C7F8B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4801 594.098L114.706 578.957L115.552 579.446L89.3261 594.586L88.4801 594.098Z",
    fill: "#5C7F8B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4411 595.807L117.667 580.667L118.513 581.155L92.2871 596.295L91.4411 595.807Z",
    fill: "#5C7F8B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4022 597.516L120.628 582.376L121.474 582.864L95.2482 598.005L94.4022 597.516Z",
    fill: "#5C7F8B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3632 599.226L123.589 584.085L124.435 584.574L98.2092 599.714L97.3632 599.226Z",
    fill: "#5C7F8B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M100.324 600.935L126.55 585.795L127.396 586.283L101.17 601.424L100.324 600.935Z",
    fill: "#5C7F8B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 602.645L129.512 587.504L130.358 587.993L104.131 603.133L103.285 602.645Z",
    fill: "#5C7F8B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M106.246 604.354L132.473 589.214L133.319 589.702L107.092 604.842L106.246 604.354Z",
    fill: "#5C7F8B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M109.207 606.063L135.434 590.923L136.28 591.411L110.053 606.552L109.207 606.063Z",
    fill: "#5C7F8B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.168 607.773L138.395 592.632L139.241 593.121L113.014 608.261L112.168 607.773Z",
    fill: "#5C7F8B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M115.129 609.482L141.356 594.342L142.202 594.83L115.975 609.971L115.129 609.482Z",
    fill: "#5C7F8B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M118.09 611.192L144.317 596.051L145.163 596.54L118.936 611.68L118.09 611.192Z",
    fill: "#5C7F8B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.051 612.901L147.278 597.761L148.124 598.249L121.897 613.389L121.051 612.901Z",
    fill: "#5C7F8B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M124.012 614.61L150.239 599.47L151.085 599.958L124.858 615.099L124.012 614.61Z",
    fill: "#5C7F8B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M126.973 616.32L153.2 601.179L154.046 601.668L127.819 616.808L126.973 616.32Z",
    fill: "#5C7F8B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M129.935 618.029L156.161 602.889L157.007 603.377L130.781 618.518L129.935 618.029Z",
    fill: "#5C7F8B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M132.896 619.739L159.122 604.598L159.968 605.087L133.742 620.227L132.896 619.739Z",
    fill: "#5C7F8B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.857 621.448L162.083 606.308L162.929 606.796L136.703 621.937L135.857 621.448Z",
    fill: "#5C7F8B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.818 623.158L165.044 608.017L165.89 608.505L139.664 623.646L138.818 623.158Z",
    fill: "#5C7F8B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M141.779 624.867L168.005 609.726L168.851 610.215L142.625 625.355L141.779 624.867Z",
    fill: "#5C7F8B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.74 626.576L170.966 611.436L171.812 611.924L145.586 627.065L144.74 626.576Z",
    fill: "#5C7F8B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M147.701 628.286L173.927 613.145L174.773 613.634L148.547 628.774L147.701 628.286Z",
    fill: "#5C7F8B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M150.662 629.995L176.888 614.855L177.734 615.343L151.508 630.484L150.662 629.995Z",
    fill: "#5C7F8B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M153.623 631.705L179.849 616.564L180.695 617.052L154.469 632.193L153.623 631.705Z",
    fill: "#5C7F8B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M156.584 633.414L182.81 618.273L183.656 618.762L157.43 633.902L156.584 633.414Z",
    fill: "#5C7F8B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M159.545 635.123L185.771 619.983L186.617 620.471L160.391 635.612L159.545 635.123Z",
    fill: "#5C7F8B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M162.506 636.833L188.732 621.692L189.578 622.181L163.352 637.321L162.506 636.833Z",
    fill: "#5C7F8B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M165.467 638.542L191.693 623.402L192.539 623.89L166.313 639.031L165.467 638.542Z",
    fill: "#5C7F8B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M168.428 640.252L194.654 625.111L195.5 625.6L169.274 640.74L168.428 640.252Z",
    fill: "#5C7F8B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M171.389 641.961L197.615 626.821L198.461 627.309L172.235 642.449L171.389 641.961Z",
    fill: "#5C7F8B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M174.35 643.67L200.576 628.53L201.422 629.018L175.196 644.159L174.35 643.67Z",
    fill: "#5C7F8B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M177.311 645.38L203.537 630.239L204.383 630.728L178.157 645.868L177.311 645.38Z",
    fill: "#5C7F8B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M180.272 647.089L206.498 631.949L207.344 632.437L181.118 647.578L180.272 647.089Z",
    fill: "#5C7F8B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M183.233 648.799L209.459 633.658L210.305 634.147L184.079 649.287L183.233 648.799Z",
    fill: "#5C7F8B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M186.194 650.508L212.42 635.368L213.266 635.856L187.04 650.996L186.194 650.508Z",
    fill: "#5C7F8B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M189.155 652.217L215.381 637.077L216.227 637.565L190.001 652.706L189.155 652.217Z",
    fill: "#5C7F8B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M192.116 653.927L218.342 638.786L219.188 639.275L192.962 654.415L192.116 653.927Z",
    fill: "#5C7F8B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M195.077 655.636L221.303 640.496L222 640.898V641.07L195.923 656.125L195.077 655.636Z",
    fill: "#5C7F8B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M221.726 671.021L222 671.179V670.863L221.726 671.021Z",
    fill: "#5C7F8B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M222 668.421V667.444L218.765 669.311L219.611 669.8L222 668.421Z",
    fill: "#5C7F8B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M222 665.002V664.025L215.804 667.602L216.65 668.09L222 665.002Z",
    fill: "#5C7F8B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M222 661.583V660.606L212.843 665.893L213.689 666.381L222 661.583Z",
    fill: "#5C7F8B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M222 658.164V657.188L209.882 664.183L210.728 664.672L222 658.164Z",
    fill: "#5C7F8B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M222 654.746V653.769L206.921 662.474L207.767 662.962L222 654.746Z",
    fill: "#5C7F8B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M222 651.327V650.35L203.96 660.764L204.806 661.253L222 651.327Z",
    fill: "#5C7F8B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M222 647.908V646.931L200.999 659.055L201.845 659.543L222 647.908Z",
    fill: "#5C7F8B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M222 644.489V643.512L198.038 657.346L198.884 657.834L222 644.489Z",
    fill: "#5C7F8B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 222.5,
    y1: 13,
    x2: 222.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AFFCF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFCB",
    stopOpacity: 0.37
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThirdLayer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/third_layer.84b78e6c.svg";
export { ForwardRef as ReactComponent };